// Simple observer to log branch reload events. Gated by REACT_APP_ENABLE_DEBUG.
import logger from './logger';

const ENABLED = process.env.REACT_APP_ENABLE_DEBUG === 'true';

export default {
  logBranchReload(version, branchId, reason = '') {
    if (!ENABLED) return;
    try {
      logger.info('BRANCH_RELOAD', `Branch reload token updated`, { version, branchId, reason, ts: new Date().toISOString() });
    } catch {
      // swallow
    }
  }
};
